import { useContext, useEffect } from 'react';
import { copy, removeFields } from '@thd-olt-functional/utils';
import {
  useDataModel,
  params,
  string as stringType,
  arrayOf as arrayType,
  customType
} from '@thd-nucleus/data-sources';
import { CustomerContext } from '../components/CustomerContext';

/*
apollo has some race condition and because this hook is called recursively with ds
useDataModel -> useStore -> useMembershipInformation -> useDataModel
there is functionality in the cache for it to return in loading state for loyaltyMembership
even when its succesfully returned and in cache. As a workaround changing fetchPolicy
to cache-only forces it to pull from cache early.
*/

let hasData = false;
export const useMembershipInformation = ({ customerType }) => {

  const isClient = typeof window !== 'undefined';

  if (!isClient || customerType !== 'B2B') {
    return {
      apiResponse: {
        data: null,
        error: null,
        loading: null,
      },
      customerType,
    };
  }
  /*
 due to this hook being under this condition is causing us to have a "Rendered more
 hooks than the last render" error come up. If we move this above the if we cause
 a large FID spike in b2c experiences so we will be keeping the error as a trade
 off for core web vitals performance for the time being. This is the same for the
 next 3 eslint disables for rules of hooks
 */
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { membershipInformation: savedMembershipInformation } = useContext(CustomerContext);

  if (savedMembershipInformation) {
    return {
      apiResponse: {
        data: { loyaltyMembership: savedMembershipInformation },
        error: null,
        loading: false,
      },
      customerType,
    };
  }

  const options = {
    ssr: false,
    dataModel: useMembershipInformation.dataModel,
    fetchPolicy: hasData ? 'cache-only' : 'cache-first',
    mounted: true,
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, loading, error } = useDataModel('loyaltyMembership', options);

  let loyaltyData = null;
  if (data) {
    hasData = true;
    const dataClone = copy(data);
    loyaltyData = removeFields(dataClone.data, ['__typename']) || { loyaltyMembership: null };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (loyaltyData && !loading) {
      // eslint-disable-next-line no-unused-expressions
      window.THDCustomer?.default?.setMembershipInformation(loyaltyData.loyaltyMembership);
    }
  }, [loading]);

  // Return if loyaltyMembership Information is provided by query
  return {
    apiResponse: {
      data: loyaltyData,
      error,
      loading,
    },
    customerType,
  };
};

useMembershipInformation.dataModel = {
  loyaltyMembership: params().shape({
    svocID: stringType(),
    programTiers: arrayType(
      customType('ProgramTiers').shape({
        tier: stringType(),
        program: stringType(),
      })
    ),
  }),
};
